module.exports = __webpack_public_path__ + "static/media/DSC01485.6a376d37.jpg";